<template>
	<v-row class="full-height">
		<v-col cols="12" class="flex-none">
			<v-row class="message-form">
				<v-col cols="2">
					<label>ID</label>
					<div class="form-input">
						<v-text-field
							outlined
							dense
							hide-details="auto"
							v-model="activeMessage.messageIdLabel"
							disabled
						></v-text-field>
					</div>
					<!--TODO replace ID with rep once backend is updated to handle an id Int -->
					<!-- <label>Sales Rep</label>
                    <div class="form-input">
                        <v-select
                            v-model="activeMessage.messageIdLabel"
                            :items="salesReps"
                            item-text="name"
                            item-value="salesRepId"
                            dense
                            outlined
                            hide-detail
                        ></v-select>
                    </div> -->
				</v-col>
				<v-col cols="10">
					<div v-if="!editMode" class="message-form-actions">
						<v-btn
							depressed
							outlined
							:disabled="!activeMessage.messageId"
							@click="deleteWarning = !deleteWarning"
							>Delete</v-btn
						>
						<v-btn
							depressed
							outlined
							:disabled="editMode || !activeMessage.messageId"
							@click="editMode = !editMode"
							>Edit</v-btn
						>
						<v-btn depressed outlined @click="createMessage()">Create New</v-btn>
					</div>
					<div v-else class="message-form-actions">
						<v-btn depressed outlined @click="cancelEdits()">Cancel</v-btn>
						<v-btn depressed color="primary" @click="saveMessage()">Save</v-btn>
					</div>
				</v-col>

				<v-col cols="12">
					<label>Message</label>
					<div class="form-input">
						<v-textarea
							outlined
							hide-details="auto"
							v-model="activeMessage.messageContent"
							:disabled="!editMode"
						></v-textarea>
					</div>
				</v-col>
			</v-row>
		</v-col>

		<v-col cols="12" class="flex-none">
			<div class="divider">&nbsp;</div>
		</v-col>

		<v-col cols="12" class="flex-auto">
			<label>Message Comment List</label>
			<div class="message-list">
				<div v-if="initData" class="loading-overlay">
					<div class="loading-dot">&nbsp;</div>
					<div class="loading-dot">&nbsp;</div>
					<div class="loading-dot">&nbsp;</div>
					<div class="loading-dot">&nbsp;</div>
					<div class="loading-dot">&nbsp;</div>
				</div>
				<ul @drop="onDrop()" @dragover.prevent="startSort ? sortItems($event) : null">
					<li
						v-for="(data, i) in messageList"
						:key="i"
						:class="activeMessage.messageContent == data.messageContent ? 'active' : null"
						:style="`order: ${data.sequence}`"
						:draggable="startSort"
						@click="setMessage(data)"
					>
						<v-icon
							v-if="editMode"
							style="font-size: 2rem"
							v-text="'mdi-arrow-split-horizontal'"
							@mousedown="triggerSorting($event, data)"
						></v-icon>
						<p>{{ data.messageContent }}</p>
					</li>
				</ul>
			</div>
		</v-col>

		<WarningModal
			v-if="deleteWarning"
			:showModal="deleteWarning"
			:message="'Are you sure you want to delete the selected message?'"
			:itemList="[activeMessage]"
			:itemListKey="'messageContent'"
			:cancelText="'No, Cancel'"
			:confirmText="'Yes, Delete'"
			@cancel="deleteWarning = false"
			@confirm="
				deleteMessage();
				deleteWarning = false;
			"
		/>
	</v-row>
</template>

<script>
import gql from "graphql-tag";
import WarningModal from "@/components/WarningModal.vue";
import { getApiUrl } from "@/helpers";
export default {
	name: "Messages",
	components: {
		WarningModal,
	},
	data() {
		return {
			initData: false,
			deleteWarning: false,
			activeMessage: {},
			messageList: [],
			orderTypes: [
				{ text: "Sales Order", orderTypeId: 1 },
				{ text: "Quote", orderTypeId: 2 },
				{ text: "Sample", orderTypeId: 3 },
			],
			salesReps: [],
			editMode: false,
			startSort: false,
			dragItemElement: null,
			dragItem: null,
		};
	},
	apollo: {
		messageList: {
			query() {
				return gql`
					query {
						message(skip: 0, take: 15, order: { sequence: ASC }) {
							items {
								messageId
								messageIdLabel
								messageContent
								orderTypeId
								sequence
							}
						}
					}
				`;
			},
			update(data) {
				if (this.initData) {
					this.initData = false;
				}
				return data.message.items;
			},
		},
		salesReps: {
			query() {
				return gql`
					query {
						salesReps(take: 500, order: { name: ASC }) {
							items {
								salesRepId
								salesRepNumber
								name
								inactiveDate
								sequence
							}
							pageInfo {
								hasNextPage
								hasPreviousPage
							}
						}
					}
				`;
			},
			update: (data) => data.salesReps.items,
		},
	},
	methods: {
		setMessage(message) {
			//if user is currently creating or editing a message make sure to clear the state and remove message if its new
			if (this.editMode) {
				this.activeMessage.messageId == null ? this.messageList.splice(0, 1) : null;
				this.editMode = false;
			}

			//check if the selected message is the current activeMessage and unselect if it is
			if (message.messageId == this.activeMessage.messageId) {
				this.activeMessage = {};
			} else {
				this.activeMessage = message;
			}
		},

		createMessage() {
			//set default message data
			const newMessage = {
				messageIdLabel: "",
				orderTypeId: "",
				sequence: 0,
				messageContent: "",
			};

			this.activeMessage = newMessage;
			this.messageList.unshift(newMessage);
			this.editMode = true;
		},

		cancelEdits() {
			//if activeMessage is new remove it
			if (this.activeMessage.messageId == null) {
				this.messageList.splice(0, 1);
				this.activeMessage = {};
			} else {
				//refetch latest message list data
				this.$apollo.queries.messageList.refetch();
			}

			this.editMode = false;
		},

		async deleteMessage() {
			try {
				const res = await this.$http.delete(
					getApiUrl(`/api/settings/message/${this.activeMessage.messageId}`)
				);
				console.log(res);

				//refresh latest messages
				this.$apollo.queries.messageList.refetch();
			} catch (error) {
				console.log(error);
			}
		},

		async saveMessage() {
			try {
				let res;
				if (this.activeMessage.messageId) {
					res = await this.$http.put(
						getApiUrl("/api/settings/message"),
						this.activeMessage
					);
				} else {
					res = await this.$http.post(
						getApiUrl("/api/settings/message"),
						this.activeMessage
					);
				}
				console.log(res);

				//update sequence list for newest items
				await this.updateSequenceList(res.data.messageId);

				//refresh latest messages and clear activeMessage
				this.$apollo.queries.messageList.refetch();
				this.activeMessage = {};
				this.editMode = false;
			} catch (error) {
				console.log(error);
			}
		},

		async updateSequenceList(id) {
			try {
				//create list of sequeneces and ids
				let sequenceList = this.messageList.map((obj) => {
					let sequenceObj = {
						//if no id is defined then use the passed in id (that means the user created a new entry and this needs to be added to the sequence list)
						entityId: obj.messageId ? obj.messageId : id,
						sequence: obj.sequence,
					};
					return sequenceObj;
				});

				const res = await this.$http.put(getApiUrl("/api/settings/messages/sequence"), {
					sequence: sequenceList,
				});
				console.log(res);

				return;
			} catch (error) {
				console.log(error);
			}
		},

		//drag and drop sorting functions
		onDrop() {
			//if sorting is active reset dragging states after dropping the dragged item
			if (this.dragItem) {
				this.startSort = false;
				this.dragItemElement.classList.remove("dragging");
				this.dragItemElement = null;
				this.dragItem = null;
			}
		},

		triggerSorting(event, item) {
			this.startSort = true;
			//set dragging element in data and add dragging class (this is removed on drag drop event)
			this.dragItemElement = event.target.closest(".message-list li");
			this.dragItemElement.classList.add("dragging");

			//set drag item in data
			this.dragItem = item;
		},

		renderItemOrder(item) {
			//find the matching item in sequence list
			const matchingSortItem = this.sequenceList.find((obj) => obj.messageId == item.messageId);

			return matchingSortItem ? matchingSortItem.sequence : 0;
		},

		setItemOrder(closestItem) {
			let sortedList = [];

			//get all items except the current drag item and sort them in order
			sortedList = this.messageList
				.filter((obj) => obj !== this.dragItem)
				.sort((a, b) => a.sequence - b.sequence);

			if (closestItem) {
				//find the closestItem in data by DOM style order property
				let closestSortItemIndex = sortedList.findIndex((obj) => obj.sequence == closestItem.style.order);

				//assign dragItem above the passed in closestItem
				sortedList.splice(closestSortItemIndex, 0, this.dragItem);
			} else {
				//assign the selected item to the end of its level
				sortedList.push(this.dragItem);
			}

			//set the new sequence order via index + 1
			sortedList = sortedList.map((obj, i) => {
				return { ...obj, sequence: i + 1 };
			});

			//update the message list with new sequences from the sortedList
			sortedList.forEach((item) => {
				let foundIndex = this.messageList.findIndex((obj) => obj.messageId == item.messageId);

				this.messageList[foundIndex].sequence = item.sequence;
			});
		},

		sortItems(event) {
			//get all item elements that are not the dragged item
			const nonActiveItemElements = [
				...event.target.closest(".message-list ul").querySelectorAll("li:not(.dragging)"),
			];

			//find the closest item that were above in the DOM
			let closestItem = nonActiveItemElements.reduce(
				(closest, child) => {
					const box = child.getBoundingClientRect();
					const offset = event.clientY - box.top - box.height / 2;
					if (offset < 0 && offset > closest.offset) {
						return { offset: offset, element: child };
					} else {
						return closest;
					}
				},
				{ offset: Number.NEGATIVE_INFINITY }
			).element;

			//change the item order in data by element names
			if (closestItem == null) {
				this.setItemOrder();
			} else {
				this.setItemOrder(closestItem);
			}
		},
	},
	mounted() {
		this.initData = true;
	},
};
</script>

<style lang="scss" scoped>
.message {
	&-form {
		.form-input {
			margin: 0.5rem 0;
		}

		&-actions {
			display: flex;
			height: 100%;
			width: 100%;
			justify-content: flex-end;
			align-items: flex-end;

			.v-btn {
				background-color: $color-white;
				border-color: $color-gray;
				text-transform: initial;
				margin: 0.5rem;
			}
		}
	}

	&-list {
		position: relative;
		background-color: $color-white;
		border-radius: 4px;
		height: 100%;
		padding: 0.5rem;

		ul {
			display: flex;
			flex-flow: column nowrap;
			list-style: none;
			padding-left: 0;

			li {
				display: flex;
				flex-flow: row wrap;
				align-items: center;
				font-size: 1.6rem;
				white-space: nowrap;
				transition: all 0.4s;
				border-radius: 5px;
				margin: 0.2rem 0;
				padding: 0.2rem 0.8rem;
				min-height: 2.8rem;

				.v-icon {
					margin-right: 0.8rem;
				}

				&:hover {
					cursor: pointer;
					background-color: $color-gray-light;
				}

				&.active {
					cursor: initial;
					background-color: $color-gray-light;
				}
			}
		}
	}
}
</style>
